// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r2aT","list":"styles_list__1xX5j","disableSelection":"styles_disableSelection__3GoPf"};